import get from 'lodash/get';
import flow from 'lodash/flow';
/**
 * @desc  ChangesHistoryService class.
 * @ngInject
 */

export default class ChangesHistoryService {
  /**
   * Constructor of the class.
   *
   * @param {$q} $q
   * @param {$log}  $log
   * @param {$http} $http
   */
  constructor(
    $q, $log, $http
  ) {
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;
  }

  addEmployeeFullName(data = []) {
    return data.map(item => ({
      ...item,
      employeeFullName: `${get(item, 'employee.employeeLastname', '')} ${get(item, 'employee.employeeName', '')}`
    }));
  }

  getRealizationChanges(id) {
    return this.$http({
      method: 'GET',
      url: `/SCR/changesHistory/realizations/${id}`
    })
      .then(({data}) => data, err => this.$q.reject(err))
      .then(response => flow([
        this.addEmployeeFullName
      ])(response));
  }

  getAttendanceChanges(id) {
    return this.$http({
      method: 'GET',
      url: `/SCR/changesHistory/attendance/${id}`
    })
      .then(({data}) => data, err => this.$q.reject(err))
      .then(response => flow([
        this.addEmployeeFullName
      ])(response));
  }
}
